import React, { useEffect, useState, useRef } from 'react';
import { showToastMessage, userToken, executeLaravelAPI, buttonLoadingClass } from '../../Utils';
import { Form } from 'react-bootstrap';
import { SelectToSearch } from '../SelectToSearch';
import SubmitButton from '../../shared/SubmitButton';

const ProjectEditOffers = ({selectedProjectId }) => {
    const buttonClass=useRef('theme-btn btn btn-success');
    const [buttonClassLoader, setButtonClass] = useState(buttonClass.current);
    const [projectOffers, setEditedItem] = useState({});

    useEffect(() => {    
        const getProjects = async () => {
            try {
                const result = await executeLaravelAPI(`project/view/${selectedProjectId}`, '', 'GET', userToken);
                const dataProjectDetails = result.data;
                setEditedItem(dataProjectDetails); // Set the editedItem state
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (selectedProjectId) {
            getProjects();
        }
    }, [selectedProjectId]);

    const handleSelectChange = (selectedOptions) => {
        setEditedItem(prevState => ({
            ...prevState,
            offers: selectedOptions.length > 0 ? selectedOptions.map(option => ({ id: option.value, name: option.label })) : []
        }));        
    };

    const updateProjectOffers = async (e) => {
        e.preventDefault();
        // Get all buttons with the 'theme-btn' class
        const buttons = document.getElementsByClassName('theme-btn');
        // Disable all these buttons
        for (let button of buttons) {
            button.disabled = true;
        }
        setButtonClass(`${buttonClass.current} ${buttonLoadingClass}`);
        
        try {
            if (projectOffers.offers && Array.isArray(projectOffers.offers)) {
                const offersData = { "offers": projectOffers.offers.map(offer => offer.id) };
    
                if (offersData.offers.length > 0) {
                    const updatedProjectOffersData = await executeLaravelAPI(`projectoffers/edit/${selectedProjectId}`, offersData, 'PUT', userToken);
    
                    if (updatedProjectOffersData.status === 200) {
                        const response = await executeLaravelAPI(`offersbyids`, offersData, 'POST', userToken);
                        projectOffers.offers = response.data.map(offer => ({ id: offer.id, name: offer.name }));
                        showToastMessage('Offers are updated successfully', 'top-right', 'success');
                    } else {
                        showToastMessage('Offers are not updated successfully', 'top-right', 'error');
                    }
                }
            }
        } catch (error) {
            console.error('Error updating offers:', error);
            showToastMessage('Error updating offers', 'top-right', 'error');
        } finally {
            // Reset the button class and enable all the buttons
            setButtonClass(buttonClass.current);
            for (let button of buttons) {
                button.disabled = false;
            }
        }
    }
    //console.log("Amenities",projectOffers.amenities);
    return (
        <form onSubmit={updateProjectOffers} className='projectForm'>
            <div className="row">
                <div className="col-md-12 mb-2">
                    <Form.Group className="row">
                        <label className="col-sm-12 col-form-label">Offers</label>
                        <div className="col-sm-12">
                            <SelectToSearch 
                                type={"offers"} 
                                defaultValues={projectOffers?.offers} 
                                name="offers" 
                                onChange={(selectedOptions) => handleSelectChange(selectedOptions)} 
                                typesection="project"
                            />
                        </div>
                    </Form.Group>
                </div>
            </div>
            <div className='col-12'>
                <hr></hr>
            </div>
            <div className='text-end mt-3'>
            {/* <Button variant="secondary" className="theme-btn secondary me-2">Cancel</Button> */}
            <SubmitButton variant="success" type="submit" className={buttonClassLoader} label="Update Offers" />
            </div>
        </form>
    )
}
export default ProjectEditOffers;
